import { InputGroup, Input } from 'rsuite';
import { icons } from '@shared/static/icons';
import { FormGroup } from '@shared/ui/forms/display';

export default function CardsPreviewGroup({ data, label }) {
  return (
    <div className="cards-preview-group">
      <FormGroup label={label}>
        {data?.map((item) => (
          <InputGroup inside disabled key={item.id}>
            <InputGroup.Addon>{icons['card-input']}</InputGroup.Addon>
            <Input
              value={`* ${item.details?.cardNumber?.slice(-4) ?? ''}`}
              className="primary-text"
            />
            <InputGroup.Addon className="bg-transparent">
              {item.owner?.name}
            </InputGroup.Addon>
          </InputGroup>
        ))}
      </FormGroup>
    </div>
  );
}
